import { render, staticRenderFns } from "./ImgDragSort.vue?vue&type=template&id=278f47b0&scoped=true&"
import script from "./ImgDragSort.vue?vue&type=script&lang=js&"
export * from "./ImgDragSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f47b0",
  null
  
)

export default component.exports